export const CREDIT_PACK_BASE = [
  { key: "stardust", credits: 10, usdPrice: "$2.99" },
  { key: "nebula", credits: 25, usdPrice: "$5.99", popular: true },
  { key: "supernova", credits: 70, usdPrice: "$13.99" },
];

export const PRODUCT_CODE_BY_PACK_KEY = {
  stardust: "stardust",
  nebula: "nebula",
  supernova: "supernova",
};

export const SUBSCRIPTION_PRODUCT_CODE = "eclipse_pass_monthly";

export const CREDIT_COST_REFERENCE = [
  { labelKey: "zodiac_prediction", costKey: "cost_2_credits", icon: "♈", shortCost: "2 cr" },
  { labelKey: "tarot_reading", costKey: "cost_4_credits", icon: "⊕", shortCost: "4 cr" },
  { labelKey: "wedding_date", costKey: "cost_10_credits", icon: "♡", shortCost: "10 cr" },
  { labelKey: "couple_match_reading", costKey: "cost_15_credits", icon: "囍", shortCost: "15 cr" },
];

